// extracted by css-extract-rspack-plugin
export default {"content":"ukjnIMOGnksfHVSr","fullWidth":"PAtwqLsBI8S1qiNM"};